<template>
 <Row>
    <i-col span="12">
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
         <FormItem label="服务代码" prop="code">
            <i-input v-model="formValidate.code" placeholder="请输入服务代码"></i-input>
        </FormItem>
        <FormItem label="服务名称" prop="name">
            <i-input v-model="formValidate.name" placeholder="请输入服务名称"></i-input>
        </FormItem>
               <FormItem label="服务logo">
    <Upload
        ref="upload"
        :show-upload-list="false"

        :on-success="handleSuccess"
        :data="Postdata"
        :format="['jpg','jpeg','png']"
        :max-size="2048"
        :on-format-error="handleFormatError"
        :on-exceeded-size="handleMaxSize"
        :before-upload="handleBeforeUpload"
        multiple
        type="drag"
        :action="url"
        style="display: inline-block;width:58px;">
        <div style="width: 58px;height:58px;line-height: 58px;">
          <img  :src="uploadimg" v-if="uploadimg"/>
            <Icon v-else type="camera" size="20" ></Icon>  
        </div>
    </Upload>
        </FormItem>
         <FormItem label="支持餐饮服务" prop="food">
            <RadioGroup v-model="formValidate.food">
                <Radio label="1">支持</Radio>
                <Radio label="0">不支持</Radio>
            </RadioGroup>
        </FormItem> 
        <FormItem label="支持客房服务" prop="room">
            <RadioGroup v-model="formValidate.room">
                <Radio label="1">支持</Radio>
                <Radio label="0">不支持</Radio>
            </RadioGroup>
        </FormItem>
        <FormItem label="支持线上支付" prop="money">
            <RadioGroup v-model="formValidate.money">
                <Radio label="1">支持</Radio>
                <Radio label="0">不支持</Radio>
            </RadioGroup>
        </FormItem>
         <FormItem label="支持确认响应 " prop="confirm">
            <RadioGroup v-model="formValidate.confirm">
                <Radio label="1">支持</Radio>
                <Radio label="0">不支持</Radio>
            </RadioGroup>
        </FormItem>
        <FormItem label="默认配置" prop="config">
            <i-input v-model="formValidate.config" type="textarea" :autosize="true" placeholder=""></i-input>
        </FormItem>
            <FormItem label="服务描述" >
            <i-input v-model="formValidate.short_desc" type="textarea" :autosize="true" placeholder=""></i-input>
        </FormItem>
        <FormItem label="是否可用" prop="isvalid">
            <RadioGroup v-model="formValidate.isvalid">
                <Radio label="1">是</Radio>
                <Radio label="0">否</Radio>
            </RadioGroup>
        </FormItem>
        
        <FormItem>
            <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
        </FormItem>
    </Form>
    </i-col>
    <i-col span="12"></i-col>
    </Row>
</template>
<script>
import { mapState } from "vuex";
import { updateservice } from "../../api/serviceapi";
import format from "../../constant/Json.js";
export default {
  data() {
    return {
      formValidate: {
        name: "",
        code: "",
        food: "0",
        room: "0",
        money: "0",
        isvalid: "0",
        config: "{}",
        short_desc: "",
        confirm: "0"
      },
      typestate: true, //集团类型判断
      labelInValue: true,
      ruleValidate: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }]
      },
      imgName: "",
      visible: false,
      uploadimg: null,
      Postdata: {
        imagesize: "service_logo",
        type: "service"
      },
      url: "",
      uploadList: []
    };
  },

  methods: {
    sreplace(str) {
      var whitespace =
        " \n\r\t\f\x0b\xa0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000";
      for (var i = 0, len = str.length; i < len; i++) {
        if (whitespace.indexOf(str.charAt(i)) === -1) {
          str = str.substring(i);
          break;
        }
      }
      for (i = str.length - 1; i >= 0; i--) {
        if (whitespace.indexOf(str.charAt(i)) === -1) {
          str = str.substring(0, i + 1);
          break;
        }
      }
      return whitespace.indexOf(str.charAt(0)) === -1 ? str : "";
    },
    handleSubmit(name) {
      this.typestate = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          this.updateservice();
        } else {
          this.$Message.error("请检查输入");
        }
      });
    },
    updateservice() {
      var para = {
        code: this.formValidate.code,
        name: this.formValidate.name,
        food: this.formValidate.food == "1" ? 1 : 0,
        room: this.formValidate.room == "1" ? 1 : 0,
        money: this.formValidate.money == "1" ? 1 : 0,
        isvalid: this.formValidate.isvalid == "1" ? 1 : 0,
        confirm: this.formValidate.confirm == "1" ? 1 : 0,
        config: this.sreplace(this.formValidate.config).toString(),
        logo: this.formValidate.logo,
        short_desc: this.formValidate.short_desc
      };
      this.$Loading.start();
      updateservice(para).then(res => {
        this.$Loading.finish();
        let data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
          this.$router.push({ path: "serviceindex" });
        } else {
          self.$Message.error(data.message);
        }
      });
    },
    init() {
      this.formValidate = {
        name: "",
        code: "",
        food: "0",
        room: "0",
        money: "0",
        isvalid: "0",
        config: "{}",
        short_desc: "",
        logo: ""
      };
      this.uploadimg = null;
    },
    handleSuccess(res, file) {
      this.uploadimg = res.data.url;
      this.formValidate.logo = res.data.id;
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "The file format is incorrect",
        desc:
          "File format of " +
          file.name +
          " is incorrect, please select jpg or png."
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "Exceeding file size limit",
        desc: "File  " + file.name + " is too large, no more than 2M."
      });
    },
    handleBeforeUpload() {
      const check = this.uploadList.length < 5;
      if (!check) {
        this.$Notice.warning({
          title: "Up to five pictures can be uploaded."
        });
      }
      return check;
    }
  },
  mounted() {
    if (this.$route && this.$route.query) {
      var data = this.$route.query;
      this.formValidate = data;
      this.formValidate.config = format(data.config);
      this.formValidate.food = data.food + "";
      this.formValidate.room = data.room + "";
      this.formValidate.money = data.money + "";
      this.formValidate.isvalid = data.isvalid + "";
      this.formValidate.confirm = data.confirm + "";
      this.formValidate.short_desc = data.short_desc;
      this.uploadimg = data.logo_path;
      this.formValidate.logo = data.logo_id;
    }
    let timestamp = new Date().getTime();
    if (sessionStorage.getItem("loginType")) {
      this.loginType = JSON.parse(sessionStorage.getItem("loginType"));
    }
    if (this.loginType == "正式") {
      this.url =
        "https://www.migee.net/index.php/common/component/upload?device=PC" +
        "&timestamp=" +
        timestamp;
    } else if (this.loginType == "测试") {
      this.url =
        "https://test.migee.net/index.php/common/component/upload?device=PC" +
        "&timestamp=" +
        timestamp;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/service/updte.vue